var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-5 pt-5"},[_c('VoteItem',{attrs:{"title":"Лист №47 голосования при проведении онлайн опроса собственников квартир/нежилых помещений","start_date":"01.09.19","end_date":"6.04.22","vouted_count":"85"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }